export default __webpack_public_path__ + "static/media/02.d74fe4c8.jpg";